import { concatAll } from '../operators/concatAll';
import { popScheduler } from '../util/args';
import { scheduled } from '../scheduled/scheduled';
import { from } from './from';
export function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return concatAll()(scheduler ? scheduled(args, scheduler) : from(args));
}
//# sourceMappingURL=concat.js.map